import { session, safeJsonParse } from '@farmersdog/utils';

export const STALE_CLIENT_REFRESH_STATE_KEY = 'stale-client-refresh-attempted';

export interface StaleClientRefreshState {
  timestamp: number;
}

function isValidState(obj: unknown): obj is StaleClientRefreshState {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  return typeof (obj as Record<string, unknown>).timestamp === 'number';
}

function get(): StaleClientRefreshState | null {
  const value = session.getItem(STALE_CLIENT_REFRESH_STATE_KEY);

  if (value === null) {
    return null;
  }

  const parsed = safeJsonParse<StaleClientRefreshState>(value);

  if (isValidState(parsed)) {
    return parsed;
  }

  return null;
}

function set(): void {
  const state: StaleClientRefreshState = { timestamp: Date.now() };
  session.setItem(STALE_CLIENT_REFRESH_STATE_KEY, JSON.stringify(state));
}

function clear(): void {
  session.removeItem(STALE_CLIENT_REFRESH_STATE_KEY);
}

export const staleClientRefreshState = {
  get,
  set,
  clear,
};
